import { render, staticRenderFns } from "./deductionDetail-no.vue?vue&type=template&id=fceee7b2&scoped=true"
import script from "./deductionDetail-no.vue?vue&type=script&lang=js"
export * from "./deductionDetail-no.vue?vue&type=script&lang=js"
import style0 from "./deductionDetail-no.vue?vue&type=style&index=0&id=fceee7b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceee7b2",
  null
  
)

export default component.exports